<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.documentDefinitions')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.documentDefinitions')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-5">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('documentDefinitions.documentDefinitionList')}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <input
                  type="text"
                  :placeholder="$ml.get('general.search')"
                  v-model="searchText"
                  class="form-control"
                  autocomplete="false"
                  style="margin-bottom:10px;"
                />
              <div
                v-show="documentDefinitionList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="documentDefinition in documentDefinitionList" :key="documentDefinition.id">
                      <td>
                        <span>{{documentDefinition.name}}</span>
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="getDocumentDefinition(documentDefinition.id)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
              <div v-show="documentDefinitionList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('documentDefinitions.documentDefinitionNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-7">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get('documentDefinitions.documentDefinitionInfo')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  v-show="authControl == 0"
                  @click="newDocumentDefinition()"
                  type="button"
                  class="btn btn-sm btn-warning "
                >{{$ml.get('documentDefinitions.newDocumentDefinition')}}</button>
              </div>
            </div>
            <div class="box-body" align="center">
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('documentDefinitions.documentDefinitionName')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9">
                  <input type="text" v-model="documentDefinition.name" class="form-control" />
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewDocumentDefinition && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.delete')}}</button>
                <button
                  v-show="isNewDocumentDefinition && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.save')}}</button>
                <button
                  v-show="!isNewDocumentDefinition && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.documentDefinition.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('documentDefinitions.isContinueDocumentDefinitionUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveDocumentDefinition()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.documentDefinition.name}}</p>
              <span>{{$ml.get('documentDefinitions.isContinueDocumentDefinitionSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveDocumentDefinition()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.documentDefinition.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('documentDefinitions.isContinueDocumentDefinitionDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteDocumentDefinition()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      documentDefinition: {
        id: null,
        name: "",
      },
      documentDefinitions: [],
      isNewDocumentDefinition: true
    };
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthTanimlamalar;
    },
    documentDefinitionList() {
      if(this.searchText){
        return this.documentDefinitions.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
      return this.documentDefinitions;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newDocumentDefinition() {
      this.isLoadingDetail = true;
      this.isNewDocumentDefinition = true;
      this.documentDefinition.id = null;
      this.documentDefinition.name = "";
      this.isLoadingDetail = false;
    },
    async deleteDocumentDefinition() {
      try {
        this.isLoadingDetail = true;
        let id = this.documentDefinition.id;
        const response = await this.$axios
          .delete("/DocumentDefinition/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getDocumentDefinitions();
        this.newDocumentDefinition();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },
    async saveDocumentDefinition() {
      if (this.documentDefinition.name == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterAName'));
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewDocumentDefinition) {
        try {
          let documentDefinition2 = this.documentDefinition;
          const response = await this.$axios
            .post("/DocumentDefinition", {
              name: documentDefinition2.name
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data;
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getDocumentDefinitions();
          this.newDocumentDefinition();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let documentDefinition2 = this.documentDefinition;
          const response = await this.$axios
            .put("/DocumentDefinition/" + documentDefinition2.id, {
              name: documentDefinition2.name
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getDocumentDefinitions();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getDocumentDefinition(id) {
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .get("/DocumentDefinition/GetById/" + id)
          .then(response => {
            this.isNewDocumentDefinition = false;
            this.documentDefinition.id = id;
            this.documentDefinition.name = response.data.name;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async getDocumentDefinitions() {
      try {
        this.isLoading = true;
        const documentDefinitions = [];
        const response = await this.$axios
          .get("/DocumentDefinition/GetAll")
          .then(response => {
            response.data.forEach(doc => {
              documentDefinitions.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.documentDefinitions = documentDefinitions;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage')
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getDocumentDefinitions();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/documentDefinitions/documentDefinitions.vue